import { get } from 'lodash';
import {
  SPECIFIED_PER_PERSON,
} from '../../lib/split-types';
import { defineMessages } from 'react-intl';
import { single } from 'validate.js';
import money, { format } from '../../lib/money';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  lessThanMaxProductCost: {
    id: 'claimForm.errors.lessThanMaxProductCost',
    defaultMessage: 'Can\'t be > {amount}',
  },
  noInviteeEmail: {
    id: 'claimForm.errors.noInvitee.Email',
    defaultMessage: 'Please enter a valid email',
  },
  minContribution: {
    id: 'claimForm.errors.minContribution',
    defaultMessage: 'Can\'t be less than {amount}',
  },
  noOrgEmail: {
    id: 'claimForm.errors.noOrgEmail',
    defaultMessage: 'Enter your email',
  },
  noOrgName: {
    id: 'claimForm.errors.noOrgName',
    defaultMessage: 'Enter your full name',
  },
  noOrgPassword: {
    id: 'claimForm.errors.noOrgPassword',
    defaultMessage: 'Enter your password',
  },
  maxSlots: {
    id: 'claimForm.errors.maxSlots',
    defaultMessage: 'Can\'t be more than {maxSlots}',
  },
});

const validateLessThanMaxProductCost = (amount, { purchase, intl }) => {
  const maxProductCostAmount = money(get(purchase, 'maxProductCostByAmount.amount', 0));

  if (amount.isGreaterThan(maxProductCostAmount)) {
    return formatMessage(intl)(i18n.lessThanMaxProductCost, { amount: format(maxProductCostAmount) });
  }

  return null;
};

const validateInvitee = (invitee, values, props) => {
  const errors = {};
  const minContribution = money(values.minContribution);

  if (!invitee.email) return errors;

  if (invitee.email && single(invitee.email, { email: true })) {
    errors.email = ' ';
  }

  if (invitee.fullName && !invitee.email) {
    errors.email = formatMessage(props.intl)(i18n.noInviteeEmail);
  }

  const inviteeAmount = money(invitee.allowedShareAmount);

  if (values.splitType === SPECIFIED_PER_PERSON && inviteeAmount) {
    errors.allowedShareAmount = validateLessThanMaxProductCost(
      inviteeAmount,
      props,
    );

    if (minContribution && inviteeAmount.isGreaterThan(money(0, inviteeAmount.currencyCode)) &&
      inviteeAmount.isLessThan(minContribution)) {
      errors.allowedShareAmount = formatMessage(props.intl)(i18n.minContribution,
        { amount: format(minContribution) });
    }
  }

  return errors;
};

export default (values, props) => {
  const { purchase } = props;
  const errors = {};
  const maxSlots = purchase.productOrGroupMaxSlots;
  const organizerAmount = money(values.organizerAllowedShareAmount);
  const minContribution = money(values.minContribution);

  if (!values.organizerEmail) {
    errors.organizerEmail = formatMessage(props.intl)(i18n.noOrgEmail);
  } else if (single(values.organizerEmail, { email: true })) {
    errors.organizerEmail = formatMessage(props.intl)(i18n.noInviteeEmail);
  }

  if (!values.organizerName || values.organizerName.indexOf(' ') < 0) {
    errors.organizerName = formatMessage(props.intl)(i18n.noOrgName);
  }

  if (!values.organizerPassword) {
    errors.organizerPassword = formatMessage(props.intl)(i18n.noOrgPassword);
  }

  errors.invitees = (values.invitees || []).map((invitee) => {
    return validateInvitee(invitee, values, props);
  });

  if (maxSlots && values.minSlots > maxSlots) {
    errors.minSlots = formatMessage(props.intl)(i18n.maxSlots, { maxSlots });
  }

  if (values.splitType === SPECIFIED_PER_PERSON) {
    if (minContribution) {
      errors.minContribution = validateLessThanMaxProductCost(minContribution, props);
    }

    if (organizerAmount) {
      errors.organizerAllowedShareAmount = validateLessThanMaxProductCost(organizerAmount, props);

      if (minContribution && organizerAmount.isGreaterThan(money(0, organizerAmount.currencyCode)) &&
        organizerAmount.isLessThan(minContribution)) {
        errors.organizerAllowedShareAmount =
          formatMessage(props.intl)(i18n.minContribution, { amount: format(minContribution) });
      }
    }
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/validate.js